import React, { useEffect, useState } from 'react';

import './Field.scss';

import TextField from './Fieldtypes/TextField';
import TextArea from './Fieldtypes/TextArea';
import Checkbox from './Fieldtypes/Checkbox';
import Slider from './Fieldtypes/Slider';
import Select from './Fieldtypes/Select';
import TextTitle from './Fieldtypes/TextTitle';
import TextNormal from './Fieldtypes/TextNormal';
import TextRich from './Fieldtypes/TextRich';
import SelectMulti from './Fieldtypes/SelectMulti';
import Divider from './Fieldtypes/Divider';
import Bool from './Fieldtypes/Bool';
import FileUpload from './Fieldtypes/FileUpload';
import DateSelector from './Fieldtypes/DateSelector';
import Icon from './Fieldtypes/Icon';
import SelectColor from './Fieldtypes/SelectColor';
import ReactSelect from './Fieldtypes/ReactSelect';

const isEqual = require("react-fast-compare");

function Field(props) {

    const { type } = props;
    const [value, setValue] = useState(props.value);

    const handleFieldChange = (value) => {

        setValue(value);
        if (props.onChange != undefined) {
            props.onChange(value);
        }
    }

    useEffect(() => {
    }, []);

    const renderField = (type) => {
        switch (type) {
            case "divider":
                return (
                    <Divider></Divider>
                );

            case "bool":
                return (
                    <Bool
                        title={props.title}
                        value={value}
                        defaultValue={props.value}
                        disabled={props.disabled}
                        onChange={handleFieldChange}
                        options={props.options}
                    ></Bool>
                );

            case "select":
                return (
                    <Select
                        title={props.title}
                        value={value}
                        defaultValue={props.defaultValue}
                        disabled={props.disabled}
                        onChange={handleFieldChange}
                        options={props.options}
                        onKeyDown={props.onKeyDown}
                    ></Select>
                );

            case "selectmulti":
                return (
                    <SelectMulti.SelectMulti
                        title={props.title}
                        value={value}
                        defaultValue={props.defaultValue}
                        disabled={props.disabled}
                        onChange={handleFieldChange}
                        options={props.options}
                    ></SelectMulti.SelectMulti>
                );

            case "reactselect":
                return (
                    <ReactSelect.ReactSelect
                        title={props.title}
                        value={value}
                        defaultValue={props.value}
                        placeholder={props.placeholder}
                        disabled={props.disabled}
                        onChange={handleFieldChange}
                        options={props.options}
                    ></ReactSelect.ReactSelect>
                );

            case "input":
                return (
                    <TextField
                        title={props.title}
                        value={value}
                        defaultValue={props.value}
                        disabled={props.disabled}
                        onChange={handleFieldChange}
                        onKeyDown={props.onKeyDown}
                        placeholder={props.placeholder}
                    ></TextField>
                );

            case "dateselector":
                return (
                    <DateSelector
                        title={props.title}
                        value={value}
                        defaultValue={props.value}
                        disabled={props.disabled}
                        onChange={handleFieldChange}
                        {...props}
                    ></DateSelector>
                );

            case "fileupload":
                return (
                    <FileUpload
                        title={props.title}
                        value={value}
                        defaultValue={props.value}
                        disabled={props.disabled}
                        onChange={handleFieldChange}
                        options={props.options}
                    ></FileUpload>
                );

            case "richtext":
                return (
                    <TextRich
                        title={props.title}
                        value={value}
                        defaultValue={props.value}
                        disabled={props.disabled}
                        options={props.options}
                        onChange={handleFieldChange}
                    ></TextRich>
                );

            case "textarea":
                return (
                    <TextArea
                        title={props.title}
                        value={value}
                        defaultValue={props.value}
                        disabled={props.disabled}
                        onChange={handleFieldChange}
                        placeholder={props.placeholder}
                        options={props.options}
                    ></TextArea>
                );

            case "checkbox":
                return (
                    <Checkbox
                        title={props.title}
                        value={value}
                        defaultValue={props.value}
                        disabled={props.disabled}
                        onChange={handleFieldChange}
                    ></Checkbox>
                );

            case "slider":
                return (
                    <Slider
                        title={props.title}
                        value={value}
                        defaultValue={props.value}
                        disabled={props.disabled}
                        onChange={handleFieldChange}
                        options={props.options}
                    ></Slider>
                );

            case "text_title":
                return (
                    <TextTitle
                        text={props.title}
                        options={props.options}
                    ></TextTitle>
                );

            case "text_normal":
                return (
                    <TextNormal
                        text={props.title}
                    ></TextNormal>
                );

            case "icon":
                return (
                    <Icon
                        title={props.title}
                        value={value}
                        onChange={handleFieldChange}
                        options={props.options}
                    ></Icon>
                )

            case "selectcolor":
                return (
                    <SelectColor
                        title={props.title}
                        value={value}
                        onChange={handleFieldChange}
                        disabled={props.disabled}
                    ></SelectColor>
                )
        }
    }

    useEffect(() => {
        setValue(props.value);
    }, [props]);

    return (
        <div style={{ width: "100%" }} className={props.hidden == undefined || props.hidden == false ? "field" : "field hidden"}>
            { renderField(type)}
        </div>
    );
}

export default React.memo(Field, isEqual);